var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1962 9.21415L18.6248 13.6427M18.6248 13.6427L14.1962 18.0713M18.6248 13.6427H4.23193M4.60595 8.107C6.52025 4.79775 10.0982 2.57129 14.1962 2.57129C20.3108 2.57129 25.2676 7.52814 25.2676 13.6427C25.2676 19.7573 20.3108 24.7141 14.1962 24.7141C10.0982 24.7141 6.52025 22.4877 4.60595 19.1784",
    stroke: "black",
    strokeWidth: 1.10714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn04);
export default __webpack_public_path__ + "static/media/log-in-04.4bca2f21aece78b2208c47cc67ecf843.svg";
export { ForwardRef as ReactComponent };